export const types = {
  UPDATE_VARIANT: "UPDATE_VARIANT",
};
